'use client'

import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

import { SvgPaperPlane } from '@/components/ui/icons'
import { acceptCategory, hide } from 'vanilla-cookieconsent'
import { ChatLine, LoadingChatLine } from './ChatLine'
import { COOKIE_NAME, initialMessages } from './config'
const InputMessage = ({ input, setInput, sendMessage }) => (
  <div className="mt-6 bg-zinc-900 p-2 rounded-lg bg-opacity-60 lg:w-[629px] flex clear-both w-full gap-4">
    <input
      type="text"
      aria-label="chat input"
      required
      placeholder="Type a message to start the conversation"
      className="min-w-0 flex-auto appearance-none rounded-md border text-gray-300 bg-transparent border-0 px-3 py-[calc(theme(spacing.2)-1px)] shadow-md shadow-zinc-800/5 placeholder:text-zinc-400 focus:border-teal-900 focus:outline-none focus:ring-teal-700/10 sm:text-sm mr-3 sm:mr-0"
      value={input}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          sendMessage(input)
          setInput('')
        }
      }}
      onChange={(e) => {
        setInput(e.target.value)
      }}
    />
    <button
      type="submit"
      className="lg:w-[48.65px] h-12 pl-3 pr-[12.65px] py-3 bg-blue-600 rounded-xl justify-center items-center inline-flex hover:bg-blue-500"
      onClick={() => {
        sendMessage(input)
        setInput('')
      }}
    >
      <SvgPaperPlane className="w-6 h-6" />
    </button>
  </div>
)

export function Chat({ disabled, setIsCookie }) {
  const [messages, setMessages] = useState(initialMessages)
  const [input, setInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [cookie, setCookie] = useCookies([COOKIE_NAME])
  const [applyField, setApplyField] = useState(false)
  const [showForm, setShowForm] = useState(false)

  useEffect(() => {
    if (cookie[COOKIE_NAME]?.codeRetrieved) {
      setApplyField(true)
    }
  }, [cookie, setCookie])

  // send message to API /api/chat endpoint
  const sendMessage = async (message) => {
    setLoading(true)
    const newMessages = [...messages, { message: message, who: 'user' }]
    setMessages(newMessages)
    const last10messages = newMessages.slice(-10)

    const response = await fetch('/api/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages: last10messages,
        user: cookie[COOKIE_NAME].randomId,
      }),
    })
    const data = await response.json()

    // strip out white spaces from the bot message
    const botNewMessage = data.text.trim()

    setMessages([...newMessages, { message: botNewMessage, who: 'bot' }])
    //if message includes the word Entry3000 set applyField to true

    setLoading(false)
  }

  const acceptAndHide = (acceptType) => {
    acceptCookies()
    acceptCategory(acceptType)
    setIsCookie(true)
    hide()
  }

  const acceptCookies = () => {
    const randomId = Math.random().toString(36).substring(7)
    const expireDate = new Date()
    expireDate.setFullYear(expireDate.getFullYear() + 1)
    setCookie(
      COOKIE_NAME,
      { randomId, codeRetrieved: false },
      { expires: expireDate },
    )
  }

  let chatBot = (
    <div
      className={disabled && 'pointer-events-none'}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <h1 className="text-center text-white text-4xl font-semibold leading-[44px]">
        {' '}
        Application Support{' '}
      </h1>
      {/* <p className="text-center text-gray-300 text-xl font-normal  leading-[30px] mt-5">
        {' '}
        We&apos;re excited to hear your innovative ideas! For any support during your
        application process, feel free to interact with our support bot,
        Annalese. She&apos;s here to assist you every step of the way.{' '}
      </p> */}

      {messages.map(({ message, who }, index) => (
        <ChatLine key={index} who={who} message={message} />
      ))}

      {loading && <LoadingChatLine />}

      {/* {messages.length < 2 && (
        <span className="mx-auto flex flex-grow text-gray-600 clear-both">
          Type a message to start the conversation
        </span>
      )} */}

      {applyField && (
        <div className="relative isolate overflow-hidden bg-gray-900 px-6 py-12 text-center shadow-2xl sm:rounded-3xl sm:px-16">
          <h2 className="mx-auto max-w-2xl text-2xl tracking-tight text-white sm:text-3xl">
            Congratulations
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-300">
            Annalese has selected your idea for the next round of the
            competition. Please click the button below to apply.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <div
              onClick={() => {
                setShowForm(true)
                window.scrollTo(0, 0)
              }}
              className="rounded-md ring-1 cursor-pointer ring-orange-400 px-3.5 py-2.5 text-sm font-semibold text-gray-100 shadow-sm hover:ring-orange-500 hover:duration-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              Get started
            </div>
          </div>
          <svg
            viewBox="0 0 1024 1024"
            className="absolute top-1/2 left-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
            aria-hidden="true"
          >
            <circle
              cx={512}
              cy={512}
              r={512}
              fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)"
              fillOpacity="0.7"
            />
            <defs>
              <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
                <stop stopColor="#7775D6" />
                <stop offset={1} stopColor="#1d6704" />
              </radialGradient>
            </defs>
          </svg>
        </div>
      )}

      <InputMessage
        input={input}
        setInput={setInput}
        sendMessage={sendMessage}
      />
    </div>
  )

  let form = (
    <iframe
      style={{ border: 'none', width: '100%', height: '1110px' }}
      src="https://xpq5ole2hvg.typeform.com/to/uDAxE4Mu"
    ></iframe>
  )

  return (
    <div className={` mt-5 `}>
      {disabled && (
        <div
          className={`bg-[rgba(26, 29, 33, 0.6)] h-[52px]  max-w-[629px] rounded-[10px] border border-[#1A1D21] xl:w-[629px] mb-6 flex flex-col justify-between sm:flex-row gap-4 sm:mx-auto mx-[20px] relative px-4 lg:px-4 m-auto`}
        >
          <div className="flex items-center gap-4">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.5 8.14844C16.5 12.5667 12.9183 16.1484 8.5 16.1484C4.08172 16.1484 0.5 12.5667 0.5 8.14844C0.5 3.73016 4.08172 0.148438 8.5 0.148438C12.9183 0.148438 16.5 3.73016 16.5 8.14844ZM9.5 4.14844C9.5 4.70072 9.05228 5.14844 8.5 5.14844C7.94772 5.14844 7.5 4.70072 7.5 4.14844C7.5 3.59615 7.94772 3.14844 8.5 3.14844C9.05228 3.14844 9.5 3.59615 9.5 4.14844ZM7.5 7.14844C6.94772 7.14844 6.5 7.59615 6.5 8.14844C6.5 8.70072 6.94772 9.14844 7.5 9.14844V12.1484C7.5 12.7007 7.94772 13.1484 8.5 13.1484H9.5C10.0523 13.1484 10.5 12.7007 10.5 12.1484C10.5 11.5962 10.0523 11.1484 9.5 11.1484V8.14844C9.5 7.59615 9.05228 7.14844 8.5 7.14844H7.5Z"
                fill="#98A2B3"
              />
            </svg>

            <h1 className="text-md font-[500] text-[#98A2B3]">
              Please accept our cookie policy to continue!
            </h1>
          </div>
          <div className="flex items-center gap-4">
            <div
              onClick={() => acceptAndHide('all')}
              className="cursor-pointer  text-blue-600 text-sm "
            >
              Accept now →
            </div>
          </div>
        </div>
      )}
      <div
        className={`rounded-2xl mt-5 ${
          disabled && 'opacity-50 cursor-not-allowed'
        }`}
      >
        {!showForm && chatBot}
        {showForm && form}
      </div>
    </div>
  )
}
